// extracted by mini-css-extract-plugin
export default {"horizontal":"styles_horizontal__EydnY","vertical":"styles_vertical__rKnUZ"};